// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lX6Vq","footerContent":"Footer_footerContent__DG5dP"};